import axios from 'axios';


const ENDPOINT = 'http://api-sbs.e-superdina.com'

export async function create (datas) {
    try {
        let url = datas.url //create
        let status = 0

        await axios.post(`${ENDPOINT}/${url}`,{
            datas
        })
        .then(res => {
            if (res.data.kode === 1){
                status = 1
            }else{
                status = 2
            }
        })

        return status;

    } catch (error) {

    }
}

export async function getall (datas) {
    try {
        let url = 'getall'
        let datareturn = []

        console.log(datas)

        await axios.post(`${ENDPOINT}/${url}`,{
            datas
        })
        .then(res => {
            datareturn = res.data.datas
        })

        return datareturn;

    } catch (error) {

    }
}

export async function getbyid (datas) {
    try {
        let url = 'getall'
        let datareturn = []

        console.log(datas)

        await axios.post(`${ENDPOINT}/${url}`,{
            datas
        })
        .then(res => {
            datareturn = res.data.datas
        })

        return datareturn;

    } catch (error) {

    }
}